/**
Author - Venkatesh Pullaganti😃
Git - https://github.com/venkatesh1146
**/

import AccountAggregator from './AccountAggregator.container';

export default AccountAggregator;
